export enum ConveyanceStatus {
  Wainting = 'wainting',
  Booked = 'booked',
  Granted = 'granted',
}
